/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plane_Proud_Pig_OfferInputs */

const fr_plane_proud_pig_offer = /** @type {(inputs: Plane_Proud_Pig_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audience`)
};

/**

* @param {Plane_Proud_Pig_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plane_proud_pig_offer = /** @type {((inputs?: Plane_Proud_Pig_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plane_Proud_Pig_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plane_proud_pig_offer(inputs)
});